import moment from 'moment';
import { app } from '../config';

export const DATE_FIELD_LABELS = {
  last_transition_timestamp: 'Fecha cambio de estado',
  numero_repertorio_timestamp: 'Fecha de repertorio',
  firma_notario: 'Fecha de firma notario',
};

export function getDefaultWindowDays() {
  return Number(app.transferenceListDefaultWindowDays || 365);
}

export function buildDefaultDateRange(field) {
  const days = getDefaultWindowDays();
  const dateTo = moment();
  const dateFrom = moment().subtract(days, 'days');
  return {
    DATE_FROM: dateFrom.format('YYYY-MM-DD'),
    DATE_TO: dateTo.format('YYYY-MM-DD'),
    DATE_RANGE: `${dateFrom.format('DD/MM/YYYY')} - ${dateTo.format('DD/MM/YYYY')}`,
    DATE_FIELD: field,
  };
}

export function clampDateRange(from, to) {
  const days = getDefaultWindowDays();
  const end = moment(to);
  let start = moment(from);
  let clamped = false;
  if (end.diff(start, 'days') > days) {
    start = moment(end).subtract(days, 'days');
    clamped = true;
  }
  return {
    DATE_FROM: start.format('YYYY-MM-DD'),
    DATE_TO: end.format('YYYY-MM-DD'),
    DATE_RANGE: `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`,
    clamped,
  };
}
